import { IP_LOCATION_FETCHED } from "../actions";
import { IPAPIResponse } from "../types";

export const initialState = {} as IPAPIResponse;

export type IPLocationState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case IP_LOCATION_FETCHED: {
			return { ...state, ...action.res };
		}

		default:
			return state;
	}
}
